import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Button, Tooltip } from 'antd';
import { dirty, update } from 'actions';
import { Full } from 'components/Page';
import AuthService from 'library/authService/auth-service';
import config from './config';

const mapStateToProps = state => ({
  action: state.api.action.data
});

const mapDispatchToProps = dispatch => ({
  resolve(data) {
    const { id } = data;
    return dispatch(update('actionResolve', id))
      .then(() => {
        dispatch(dirty(REDUCER_KEY.actions.key)); // reload actions store
      });
  }
});
/**
 * @description Prepare the data for the APi
 * @param {Object} requestor, assignees, tags, context: theme, status, priority, action_type, notification_types, ...rest
 * @return {Object}
 */
const handlePrepareData = ({
  requestor, assignees, tags, context_theme, context_object, status, priority, action_type, notification_types, follow_up_date, ...rest
}) => ({
  action_type_id: action_type.key || action_type.id,
  requestor_id: requestor && (requestor.key || requestor.id),
  status_id: status.key || status.id,
  priority_id: priority.key || priority.id,
  ...(context_theme) && { context_theme_id: context_theme.id },
  ...(context_object) && { context_object },
  notification_type_id_list: notification_types.map(type => type.key || type.id),
  assignee_id_list: assignees.map(type => type.key || type.id),
  user_tag_id_list: tags && tags.length ? tags.map(type => type.key || type.id) : [],
  follow_up_date: follow_up_date && moment()
    .isSameOrBefore(follow_up_date) ? follow_up_date : undefined,
  ...rest
});

const Actions = ({ action, permissions, resolve }) => {
  // get current user record
  const [whoami] = useState(AuthService.whoami());
  // build canReolve flag
  const canResolve = action.requestor && (
    permissions.CanAdminActions()
      .hasPermissions() || (
      whoami.id === action.requestor.id && permissions.BasicAccess()
        .hasPermissions()
    ));
  return (
    <Full
      closeOnSave
      canAdmin={permissions.CanAdminActions()
        .hasPermissions()}
      reducer={{
        item: REDUCER_KEY.action,
        list: REDUCER_KEY.actions,
        extra: REDUCER_KEY.actionType
      }}
      config={{
        ...config,
        list: {
          ...config.list,
          commands: {
            showAdd: permissions.BasicAccess()
              .hasPermissions(),
            showDelete: permissions.CanAdminActions()
              .hasPermissions()
          }
        },
        detail: {
          ...config.detail,
          commands: {
            showSaveButton: true,
            otherButtons: item => canResolve && (
              <Tooltip title="Save" placement="bottom">
                <Button
                  className="resolve-button"
                  disabled={action.status.is_resolved}
                  type="primary"
                  size="small"
                  icon="file-done"
                  onClick={() => resolve(item)}
                >
                  Resolve Action
                </Button>
              </Tooltip>
            )
          }
        }
      }}
      onPrepareData={handlePrepareData}
      permissions={permissions}
    />
  );
};

Actions.propTypes = {
  action: PropTypes.object,
  permissions: PropTypes.object.isRequired,
  resolve: PropTypes.func
};

Actions.defaultProps = {
  action: {},
  resolve() {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
